import { render, staticRenderFns } from "./JsrybgForm.vue?vue&type=template&id=51774868"
import script from "./JsrybgForm.vue?vue&type=script&lang=js"
export * from "./JsrybgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports